import React, { ChangeEvent } from 'react';
import { Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';
import useStyles from './ExpandableCard.styles';

export interface ExpandableCardProps {
  summary: React.ReactNode;
  dataQaId?: string;
  children?: React.ReactNode;
  defaultExpanded?: boolean;
  expanded?: boolean;
  disabled?: boolean;
  onChange?: (event: ChangeEvent<{}>, expanded: boolean) => void;
  className?: string;
  TransitionProps?: any;
}

const ExpandableCard: React.FC<ExpandableCardProps> = ({
  summary,
  children,
  expanded,
  defaultExpanded,
  disabled,
  dataQaId,
  onChange,
  className,
  TransitionProps,
}: ExpandableCardProps) => {
  const classes = useStyles();

  return (
    <Accordion
      classes={{
        root: classes.root,
        rounded: classes.rounded,
      }}
      className={className}
      expanded={!children ? false : expanded}
      defaultExpanded={defaultExpanded}
      disabled={disabled}
      onChange={onChange}
      data-qa-id={`expansion-panel-${dataQaId}`}
      TransitionProps={TransitionProps}
    >
      <AccordionSummary
        id={`expansion-panel-${dataQaId?.replace(/\s/g, '-')}`}
        classes={{ content: classes.content, root: classes.summaryRoot }}
        data-qa-id={`expansion-panel-summary-${dataQaId}`}
      >
        {summary}
      </AccordionSummary>
      <AccordionDetails classes={{ root: classes.detailsRoot }} data-qa-id={`expansion-panel-details-${dataQaId}`}>
        {children}
      </AccordionDetails>
    </Accordion>
  );
};

export default ExpandableCard;
